/* eslint-disable react/prop-types */
import React from 'react';
import './Loader.scss';

function Loader({ size = 140 }) {
  return (
    <div className="loader" style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100">
        {/* Track */}
        <circle cx="50" cy="50" r="40" className="loader-track" />

        {/* Animated arc */}
        <circle cx="50" cy="50" r="40" className="loader-path" />
      </svg>
    </div>
  );
}

export default Loader;
